<div
  class="flex items-center min-w-0 h-8"
  [class.opacity-40]="!enabled"
  [class.pointer-events-none]="!enabled"
  [attr.aria-disabled]="!enabled"
  data-testid="recipient-fields">
  <div
    class="flex items-center gap-2 h-8 shrink-0"
    [class.w-[189px]]="!hasPrimary"
    [class.justify-between]="!hasPrimary"
    [class.cursor-pointer]="canOpenTo"
    [class.cursor-default]="!canOpenTo"
    [attr.tabindex]="canOpenTo ? 0 : null"
    (click)="onToClick()"
    (keydown)="onToKeydown($event)"
    data-testid="recipient-to-field">
    <span class="label-large-prominent text-on-surface-variant shrink-0">{{ 'To' | translate }}</span>
    @if (hasPrimary) {
      <span
        class="flex items-center h-8 w-[154px] pl-4 pr-3 mr-3 rounded border border-outline bg-surface-bright overflow-hidden"
        data-testid="recipient-to-chip">
        <span class="label-large-prominent text-on-surface-variant min-w-0 flex-1 truncate">{{ displayName(primary) }}</span>
        @if (interactive) {
          <button
            type="button"
            class="inline-flex items-center justify-center size-[18px] shrink-0"
            (click)="onRemovePrimary($event)"
            [attr.aria-label]="'Close' | translate"
            data-testid="recipient-to-remove">
            <mat-icon class="!size-[18px] !text-[18px] !leading-[18px] text-on-surface-variant">close</mat-icon>
          </button>
        }
      </span>
    } @else {
      <button
        mat-icon-button
        type="button"
        class="!size-8"
        [disabled]="!interactive"
        (click)="onToClick(); $event.stopPropagation()"
        [attr.aria-label]="'Add' | translate"
        data-testid="recipient-to-add">
        <mat-icon class="!text-[24px] text-on-surface">add</mat-icon>
      </button>
    }
  </div>

  <span class="h-8 w-px bg-outline-variant shrink-0" aria-hidden="true"></span>

  <div
    class="flex items-center h-8 shrink-0 ml-2"
    [class.w-[189px]]="!hasCc"
    [class.justify-between]="!hasCc"
    [class.cursor-pointer]="canOpenCc"
    [class.cursor-default]="!canOpenCc"
    [attr.tabindex]="canOpenCc ? 0 : null"
    (click)="onCcClick()"
    (keydown)="onCcKeydown($event)"
    data-testid="recipient-cc-field">
    <span class="label-large-prominent text-on-surface-variant shrink-0 mr-2">{{ 'CC' | translate }}</span>
    @if (firstCc) {
      <span
        class="inline-flex items-center h-8 w-[154px] pl-4 pr-3 rounded border border-outline bg-surface-bright overflow-hidden mr-1"
        data-testid="recipient-cc-chip">
        <span class="label-large-prominent text-on-surface-variant truncate">{{ displayName(firstCc) }}</span>
        @if (interactive) {
          <button
            type="button"
            class="inline-flex items-center justify-center size-[18px] shrink-0"
            (click)="onRemoveCc($event)"
            [attr.aria-label]="'Close' | translate"
            data-testid="recipient-cc-remove">
            <mat-icon class="!size-[18px] !text-[18px] !leading-[18px] text-on-surface-variant">close</mat-icon>
          </button>
        }
      </span>
    }
    @if (overflowCount > 0) {
      <button
        type="button"
        class="inline-flex items-center justify-center size-8 rounded-full bg-primary text-on-primary label-small shrink-0 mr-1 cursor-pointer"
        (click)="onViewCc($event)"
        data-testid="recipient-cc-overflow">
        &amp; {{ overflowCount }}
      </button>
    }
    @if (interactive || !firstCc) {
      <button
        mat-icon-button
        type="button"
        class="!size-8"
        [disabled]="!interactive"
        (click)="onCcClick(); $event.stopPropagation()"
        [attr.aria-label]="'Add' | translate"
        data-testid="recipient-cc-add">
        <mat-icon class="!text-[24px] text-on-surface">add</mat-icon>
      </button>
    }
  </div>

  <span class="h-8 w-px bg-outline-variant shrink-0" aria-hidden="true"></span>
</div>
